const { protocol, host } = window.location;

export const hasSubDomain = host.split('.')[2] && host.split('.')[0] !== 'www';

export const getFullUrl = (slug, path = '') => {
  const subDomain = slug ? `${slug}.` : '';
  // remove www/subDomain from host
  const hostname =
    (hasSubDomain &&
      host
        .split('.')
        .slice(1, 3)
        .join('.')) ||
    (host.indexOf('www.') && host) ||
    host.replace('www.', '');
  return `${protocol}//${subDomain}${hostname}${path}`;
};

export function checkIsURLPointToImage(url: string) {
  return url.match(/\.(jpeg|jpg|gif|png)$/) != null;
}
